// src/data/avis.js
// ─────────────────────────────────────────────────────────────
//  AVIS GOOGLE — Le Chalet des Flandres
//  👉 Pour mettre à jour : modifie simplement les valeurs ci-dessous.
//     - noteGlobale  : ta note Google (ex : 4.4)
//     - nbAvis       : nombre total d'avis Google
//     - lienGoogle   : lien vers ta fiche Google (bouton "Voir tous les avis")
//     - avis[]       : tes meilleurs avis à afficher (texte, auteur, note)
// ─────────────────────────────────────────────────────────────

export const noteGlobale = 4.4;
export const nbAvis = 137;

// ← Lien de la fiche Google "Le Chalet des Flandres"
export const lienGoogle = 'https://maps.app.goo.gl/6PHZi74aqB34nPEX6';

export const avis = [
  {
    auteur: 'Diana S.',
    note: 5,
    texte: "Nous y avons célébré mes fiançailles, tout était super. Le restaurant était très bon et dans un endroit isolé, les enfants couraient dans la cour sans aucun problème. La nourriture est très savoureuse !",
    date: '2024',
  },
  {
    auteur: 'Alex A.',
    note: 5,
    texte: "À l'occasion de notre union civile, nous avons célébré cette soirée au Chalet. Chaleureux, excellente cuisine, service impeccable. Merci pour tout !",
    date: 'Oct. 2023',
  },
  {
    auteur: 'Jean-Paul B.',
    note: 5,
    texte: "C'était une soirée privée pour un anniversaire. Le personnel, le service et le repas étaient très bien. Merci à l'équipe !",
    date: 'Déc. 2024',
  },
];
